import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["title", "before", "after", "body"]

  show(event) {
    const button = event.relatedTarget
    if (!button) return

    this.titleTarget.textContent = button.dataset.previewTitle || ""
    this.bodyTarget.scrollTop = 0
    this.beforeTarget.src = button.dataset.previewBeforeUrl
    this.afterTarget.src = button.dataset.previewAfterUrl
  }

  hide() {
    this.beforeTarget.removeAttribute("src")
    this.afterTarget.removeAttribute("src")
  }
}
